"use strict";import{ColorArea as e}from"./src/ColorArea.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-color-area",e);
//# sourceMappingURL=sp-color-area.js.map
